import React from 'react';
import { clsx } from 'clsx';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, helperText, className, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-foreground mb-1">
            {label}
          </label>
        )}
        
        <textarea
          ref={ref}
          className={clsx(
            'w-full px-3 py-2 border border-input rounded-lg shadow-sm placeholder-muted-foreground bg-background text-foreground',
            'focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring',
            'disabled:bg-muted disabled:text-muted-foreground',
            'min-h-[80px] resize-vertical',
            error && 'border-destructive focus:ring-destructive',
            className
          )}
          {...props}
        />
        
        {error && (
          <p className="mt-1 text-sm text-destructive">{error}</p>
        )}
        
        {helperText && !error && (
          <p className="mt-1 text-sm text-muted-foreground">{helperText}</p>
        )}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';